export default __webpack_public_path__ + "2f6a8794572945f59c0b6df8aa91c164.png";